import loopback from "@/services/loopback";
import modelObject from "@/services/lb.services";

modelObject.setModel("RatesCrossdock");

let RatesCrossDock = Object.assign(
  {},
  {
    relation: "",

    createRatesCrossDock(data) {
      return loopback.post(`/${this.model}`, data);
    },

    updateRatesCrossDock(id, data) {
      return loopback.patch(`/${this.model}/${id}`, data);
    }
  },
  modelObject
);

export default RatesCrossDock;
